unable to read source [project]/packages/src/components/base/layout/stack/HStack.tsx